<template>
  <div @click="toHome" class="logo">天机 · 农业大数据系统</div>
</template>
<script>
export default {
  methods: {
    toHome () {
      this.$store.dispatch('home/getData')
      this.$store.dispatch('right/getCounty')
      this.$store.commit('right/setSelectedProvince', '')
      this.$store.commit('right/setSelectedCity', '')
      this.$router.push({
        name: 'home'
      })
    }
  }
}
</script>
<style>
.logo {
  font-size: 22px;
  color: #cfe1fc;
  text-align: center;
  height: 50px;
  background-color: #005582;
  line-height: 50px;
  display: block;
  text-decoration: none;
  margin: 0 -20px 26px -20px;
  cursor: pointer;
}
</style>
